import { apiUrl, apiUrlV2 } from "../constants/apiUrl"

const initialState = {
  creatingUnitFile: false,
  uploadingBos: false,
  bosFile: null,
  showMarkSoldForm: false,
  unitFiles: []
}

const createUnitFilesSlice = (set, get) => ({
  ...initialState,
  createUnitFile: async(body, unitId) => {
    set((state) => ({ creatingUnitFile: true }))
    try {
      const response = await fetch(
        `${apiUrl}/unit-files`, {
        method: 'POST',
        headers: { 'Authorization': get().requestHeaders['Authorization']},
        body: body
        }
      )
      const data = await response.json()

      if (response.status === 200) {
        get().setSuccessMessage('Bill of Sale successfully uploaded')
        get().fetchUnit(unitId)
      }
    } catch (err) {
      get().setErrMessage('There was an error uploading this file.')
    } finally {
      set((state) => ({ creatingUnitFile: false }))
    }
  },
  setUploadingBos: (boolean) => {
    set((state) => ({uploadingBos: boolean}))
  },
  setBosFile: (file) => {
    set((state) => ({bosFile: file}))
  },
  setShowMarkSoldForm: (boolean) => {
    set((state) => ({showMarkSoldForm: boolean}))
  },
  fetchUnitFiles: async (unitId, { photo, perPage, onSuccess } = {}) => {
    try {
      const params = new URLSearchParams()
      if (photo) params.append('photo', true)
      if (perPage) params.append('per_page', perPage)
      const query = params.toString()
      const response = await fetch(
        `${apiUrlV2}/units/${unitId}/unit_files${query ? `?${query}` : ''}`,
        { headers: get().requestHeaders }
      )
      const data = await response.json()
      set(() => ({ unitFiles: data.data }))
      if (onSuccess) { onSuccess() }
    } catch (err) {
      get().logError('Unable to retrieve unit files at this time.', err)
    }
  },
  clearUnitFiles: () => set({ unitFiles: [] }),
  resetUnitFilesSlice: () => set(initialState)
})

export default createUnitFilesSlice